export enum PaymentShape {
  PackPurchase = "PackPurchase",
  Subscription = "Subscription",
  Standalone = "Standalone",
  VisitAccount = "VisitAccount",
}
